import React from 'react'

const FunctionalContext = React.createContext({
  onChange: undefined, onComment: undefined, comments: {}, params: {}
})
export default FunctionalContext
